import { setUserTypeCookie } from "./cookieFunctions";

const controlPanelPopover =
  '<div class="row">    <div class="col-sm text-center"><i id="basicUserPreviousButton" class="bi bi-arrow-left-square-fill highlight-color"></i></div>    <div class="col-sm text-center"><i id="basicUserHelpCloseButton" class="bi bi-x-square-fill highlight-color"></i></div>    <div class="col-sm text-center"><i id="basicUserHelpNextButton" class="bi bi-arrow-right-square-fill highlight-color"></i></div>  </div>';

const popoverCloseButton =
  '<i id="basicUserHelpCloseButton" class="float-right bi bi-x-square-fill  close highlight-color menu-basic-user-help-button"></i>';

let aktuellerSchritt = 0;
var allPopoversContentArray;
let basicUserHelpActivated = false;
let userHelpSwitcherSelector = ".enable-basic-user-help";
let userHelpIconSelector = ".menu-basic-user-help-button";
let eventlistenersAllreadySet = false;

// DOM-Referenzen — werden in initializeBasicUserHelp() gesetzt, nicht auf Modul-Ebene
let basicSearchHelpIconEl = null;
let accordionMenue = null;

/**
 * Initialisiert die UserhilfeFunktion
 */
export async function initializeBasicUserHelp() {
  // DOM-Referenzen erst hier auflösen — nach vollständigem Seitenload
  basicSearchHelpIconEl = document.querySelector("#basicUserHelpTreeSearch");
  accordionMenue = document.getElementsByClassName("accordion-new");

  // Layer-Hilfe-Button erstellen
  document.querySelector(".ol-zoom")?.insertAdjacentHTML(
    "beforeend",
    '<button class="menu-basic-user-help-button d-none" type="button" title="Hilfe" id="basicUserHelpLayers">?</button>'
  );

  allPopoversContentArray = await initializeHelpPopoverArray();
  allPopoversContentArray = allPopoversContentArray.filter(Boolean);
  await createPopovers(allPopoversContentArray);
  await startUserHelpMenu();

  document.addEventListener("change", (e) => {
    if (!e.target.matches(userHelpSwitcherSelector)) return;
    if (e.target.checked) {
      document.querySelectorAll(userHelpIconSelector).forEach(el => el.classList.remove("d-none"));
      startBasicUserHelp();
    } else {
      document.querySelectorAll(userHelpIconSelector).forEach(el => el.classList.add("d-none"));
      document.querySelectorAll(".popver").forEach(el => el.classList.add("d-none"));
      closeAllPopovers();
      aktuellerSchritt = 0;
    }
  });

  document.addEventListener("click", (e) => {
    if (e.target.matches("#basicUserHelpCloseButton")) closeAllPopovers();
  });
}

/**
 * Creaate Object Array with Popover Anchor and Content
 */
function initializeHelpPopoverArray() {
  let popOversArray = new Array();

  popOversArray[0] = new Object();
  popOversArray[0]["Anchor"] = "#basicUserHelpTreeSearch";
  popOversArray[0]["Title"] = "Suchanfrage (Schritt 1)";
  popOversArray[0]["Placement"] = "right";
  popOversArray[0]["Content"] =
    '<ol class="list-group list-group-numbered"><li class="list-group-item">Wählen Sie im oberen Feld eine Eigenschaft (z. B. Baumart).</li><li class="list-group-item">Geben Sie einen Suchbegriff ein (z.B. Eiche).</li><li class="list-group-item">Wählen Sie die gewünschte Eigenschaft in der Autovervollständigung aus.</li><li class="list-group-item">Senden Sie de Suche ab.</li>';

  popOversArray[10] = new Object();
  popOversArray[10]["Anchor"] = "#basicUserHelpTagSearch";
  popOversArray[10]["Title"] = "Experten Suche (Opt.)";
  popOversArray[10]["Placement"] = "right";
  popOversArray[10]["Content"] =
    '<ol class="list-group list-group-numbered"><li class="list-group-item">Die Expertensuche stellt alle in der Datenbank gespeicherten Eigenschaften bereit.</li><li class="list-group-item">Wählen Sie die für Sie zutreffenden Werte aus.</li><li class="list-group-item">Senden Sie die Suche ab.</li><li class="list-group-item">Das Ergebnis kann auch in tabellarischer Form angezeigt werden.</li>';

  popOversArray[20] = new Object();
  popOversArray[20]["Anchor"] = "#basicUserHelpBestaende";
  popOversArray[20]["Title"] = "Waldähnliche Bestände (Opt.)";
  popOversArray[20]["Placement"] = "right";
  popOversArray[20]["Content"] =
    '<ol class="list-group list-group-numbered"><li class="list-group-item">Wählen Sie im oberen Feld eine Eigenschaft.</li><li class="list-group-item">Geben Sie einen Suchbegriff ein.</li><li class="list-group-item">Wählen Sie die gewünschte Eigenschaft in der Autovervollständigung aus.</li><li class="list-group-item">Senden Sie de Suche ab.</li>';

  popOversArray[3] = new Object();
  popOversArray[3]["Anchor"] = "#basicUserHelpLayers";
  popOversArray[3]["Title"] = "Ebenen auswählen (Schritt 2)";
  popOversArray[3]["Placement"] = "left";
  popOversArray[3]["Content"] =
    '<ol class="list-group list-group-numbered"><li class="list-group-item">Wenn gewünscht, wechseln Sie im oberen rechten Bereich der Website die Kartenebene (z. B. DWD-Winddaten).</li></ol>';

  popOversArray[4] = new Object();
  popOversArray[4]["Anchor"] = "#basicUserHelpResetSearch";
  popOversArray[4]["Title"] = "Suche zurücksetzen (Schritt 3)";
  popOversArray[4]["Placement"] = "right";
  popOversArray[4]["Content"] =
    '<ol class="list-group list-group-numbered"><li class="list-group-item">„Klicken Sie auf »Suche zurücksetzen«, um die Suche neu zu starten.</li></ol>';

  return popOversArray;
}

/**
 * Create BasicUser Help Popovers and Bind/Anchor them
 */
function createPopovers(allPopoversContentArray) {
  let allPopovers = new Array();
  allPopoversContentArray.forEach(function (popoverContent) {
    let popOverAnchor = document.querySelector(String(popoverContent.Anchor));
    if (popOverAnchor != null) {
      let popover = new bootstrap.Popover(popOverAnchor, {
        html: true,
        content: popoverContent.Content + controlPanelPopover,
        animation: true,
        title: String(popoverContent.Title) + popoverCloseButton,
        placement: String(popoverContent.Placement),
        trigger: "click",
      });
      allPopovers.push(popover);
    }
  });
  return allPopovers;
}

/**
 * Schrittweise Anzeige der Hilfestellung
 */
function startUserHelpMenu() {
  const basicUserButton = document.getElementById("basicUserButton");
  if (basicUserButton) {
    basicUserButton.onclick = function () {
      setUserTypeCookie("BasicUser");
      startBasicUserHelp();
    };
  }

  const hilfeWeiterButton = document.getElementById("hilfeWeiterButton");
  if (hilfeWeiterButton) {
    hilfeWeiterButton.addEventListener("click", showNextHelpStep);
  }
}

function showNextHelpStep() {
  if (aktuellerSchritt === allPopoversContentArray.length - 1) return;

  const anchorCurrent = document.querySelector(String(allPopoversContentArray[aktuellerSchritt].Anchor));
  const anchorNext = document.querySelector(String(allPopoversContentArray[aktuellerSchritt + 1].Anchor));

  bootstrap.Popover.getInstance(anchorCurrent)?.hide();
  bootstrap.Popover.getOrCreateInstance(anchorNext).show();
  aktuellerSchritt++;
}

function showPreviousHelpStep() {
  if (aktuellerSchritt <= 0) return;

  const anchorCurrent = document.querySelector(String(allPopoversContentArray[aktuellerSchritt].Anchor));
  const anchorPrevious = document.querySelector(String(allPopoversContentArray[aktuellerSchritt - 1].Anchor));

  bootstrap.Popover.getInstance(anchorCurrent)?.hide();
  bootstrap.Popover.getOrCreateInstance(anchorPrevious).show();
  aktuellerSchritt--;
}

/**
 * Schließen des Popovers
 */
function closeAllPopovers() {
  document.querySelectorAll(userHelpIconSelector).forEach(el => bootstrap.Popover.getInstance(el)?.hide());
  allPopoversContentArray.forEach(function (value) {
    const el = document.querySelector(String(value.Anchor));
    if (el) bootstrap.Popover.getInstance(el)?.hide();
  });
}

function startBasicUserHelp() {
  bootstrap.Modal.getInstance(document.getElementById("staticBackdrop"))?.hide();
  document.querySelectorAll(".menu-basic-user-help-button").forEach(el => el.classList.remove("d-none"));

  const switcher = document.querySelector(userHelpSwitcherSelector);
  if (switcher) {
    switcher.checked = true;
    switcher.dispatchEvent(new Event("change"));
  }

  if (accordionMenue && accordionMenue[0]) {
    accordionMenue[0].classList.toggle("active");
    var panel = accordionMenue[0].nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  }

  if (basicSearchHelpIconEl) {
    bootstrap.Popover.getOrCreateInstance(basicSearchHelpIconEl).show();
  }

  if (!eventlistenersAllreadySet) {
    document.addEventListener("click", (e) => {
      if (e.target.matches("#basicUserHelpNextButton")) showNextHelpStep();
      if (e.target.matches("#basicUserPreviousButton")) showPreviousHelpStep();
    });
    eventlistenersAllreadySet = true;
  }
}
